import { useEffect } from "react";

import { useTranslation } from "react-i18next";

import GeneralInput from "components/GeneralInput";
import Switch from "components/Switch";

import {
  ContainerFormOneLabel,
  ContainerFormOneLabelSwitch,
} from "../../StyleCSS/bodyCreateEdit";
import { ContainerInput } from "../style";

interface AttendantCreateEdit {
  nameAttendant?: string;
  documentAttendant?: string;
  emailAttendant?: string;
  onChangeName: (e: string) => unknown;
  onChangeDocument: (e: string) => unknown;
  onChangeEmail: (e: string) => unknown;
  active: boolean;
  onChangeSwitch?: (e: boolean) => unknown;
  attendantRoleDropSelected?: any;
  attendantRoleName?: string;
  setAttendantRoleDropSelected: (e: number) => unknown;
  attendantRoleId?: number;
  fieldError: boolean;
}

export const CreateEditAttendant = (
  props: AttendantCreateEdit,
): JSX.Element => {
  const { t } = useTranslation();

  useEffect(() => {
    return () => {
      props.onChangeName("");
      props.onChangeDocument("");
      props.onChangeEmail("");
    };
  }, []);

  return (
    <ContainerFormOneLabel>
      <ContainerFormOneLabelSwitch>
        <Switch
          id="react-switch"
          dataTest="switch_active"
          onChange={() =>
            props.onChangeSwitch ? props.onChangeSwitch(!props.active) : null
          }
          checked={props.active}
          label={t("common.active")}
        />
      </ContainerFormOneLabelSwitch>
      <ContainerInput>
        <GeneralInput
          id="name_attendant"
          error={!props.nameAttendant && props.fieldError}
          value={props.nameAttendant ?? ""}
          required
          data-cy="teste"
          onChange={(e) => props.onChangeName(e)}
          name={"name_attendant"}
          label={t("common.name")}
          maxLength={50}
        />
      </ContainerInput>

      <ContainerInput>
        <GeneralInput
          id="document_attendant"
          error={!props.documentAttendant && props.fieldError}
          value={props.documentAttendant?.replace(/[^\d.-]+/g, "") ?? ""}
          required
          data-cy="teste_document_attendant"
          onChange={(e) => props.onChangeDocument(e)}
          name={"document_attendant"}
          label={t("common.document")}
          maxLength={30}
        />
      </ContainerInput>
      <ContainerInput>
        <GeneralInput
          id="email_attendant"
          error={
            !!props.emailAttendant?.trim()?.length &&
            !props.emailAttendant?.includes("@") &&
            props.fieldError
          }
          value={props.emailAttendant ?? ""}
          data-cy="teste_email_attendant"
          onChange={(e) => props.onChangeEmail(e)}
          name={"email_attendant"}
          label={t("common.email")}
          maxLength={50}
        />
      </ContainerInput>
    </ContainerFormOneLabel>
  );
};
